'use strict'; // Load modules

var _classCallCheck = require("/home/solagro/htdocs/api.solagroteam.com/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/solagro/htdocs/api.solagroteam.com/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/solagro/htdocs/api.solagroteam.com/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/solagro/htdocs/api.solagroteam.com/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/solagro/htdocs/api.solagroteam.com/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Any = require('../any');

var Hoek = require('hoek'); // Declare internals


var internals = {};

internals.Binary = /*#__PURE__*/function (_Any) {
  _inherits(_class, _Any);

  var _super = _createSuper(_class);

  function _class() {
    var _this;

    _classCallCheck(this, _class);

    _this = _super.call(this);
    _this._type = 'binary';
    return _this;
  }

  _createClass(_class, [{
    key: "_base",
    value: function _base(value, state, options) {
      var result = {
        value
      };

      if (typeof value === 'string' && options.convert) {
        try {
          result.value = Buffer.from(value, this._flags.encoding);
        } catch (e) {}
      }

      result.errors = Buffer.isBuffer(result.value) ? null : this.createError('binary.base', null, state, options);
      return result;
    }
  }, {
    key: "encoding",
    value: function encoding(_encoding) {
      Hoek.assert(Buffer.isEncoding(_encoding), 'Invalid encoding:', _encoding);

      if (this._flags.encoding === _encoding) {
        return this;
      }

      var obj = this.clone();
      obj._flags.encoding = _encoding;
      return obj;
    }
  }, {
    key: "min",
    value: function min(limit) {
      Hoek.assert(Number.isSafeInteger(limit) && limit >= 0, 'limit must be a positive integer');
      return this._test('min', limit, function (value, state, options) {
        if (value.length >= limit) {
          return value;
        }

        return this.createError('binary.min', {
          limit,
          value
        }, state, options);
      });
    }
  }, {
    key: "max",
    value: function max(limit) {
      Hoek.assert(Number.isSafeInteger(limit) && limit >= 0, 'limit must be a positive integer');
      return this._test('max', limit, function (value, state, options) {
        if (value.length <= limit) {
          return value;
        }

        return this.createError('binary.max', {
          limit,
          value
        }, state, options);
      });
    }
  }, {
    key: "length",
    value: function length(limit) {
      Hoek.assert(Number.isSafeInteger(limit) && limit >= 0, 'limit must be a positive integer');
      return this._test('length', limit, function (value, state, options) {
        if (value.length === limit) {
          return value;
        }

        return this.createError('binary.length', {
          limit,
          value
        }, state, options);
      });
    }
  }]);

  return _class;
}(Any);

module.exports = new internals.Binary();